module.exports = __webpack_public_path__ + "img/winerackdog18.32b67a60.jpg";